module.exports = __webpack_public_path__ + "static/media/dundercastel-26_Small.408ffbdf.jpg";